class SocialSection extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.enableParalax == "true") {
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.media = this.querySelectorAll(".social-image-container");
    }
  }

  connectedCallback() {
    this.intersectionOptions = {
      root: null,
      rootMargin: "-50% 0% -50% 0%",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersection,
      this.intersectionOptions
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {}

  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        window.addEventListener("scroll", this.handleScroll);
      } else {
        window.removeEventListener("scroll", this.handleScroll);
      }
    });
  }

  handleScroll() {
    this.media.forEach((mediaItem) => {
      const speed = mediaItem.dataset.speed || 1;
      const val =
        window.scrollY + window.innerHeight / 2 - this.closest("div").offsetTop;
      const scale4k = mediaItem.dataset["scale-4k"];
      const scale5k = mediaItem.dataset["scale-5k"];

      if (window.innerWidth >= 2560 && window.innerWidth <= 3840) {
        mediaItem.style.transform = `scale(${scale4k}) translateY(${
          val * -speed
        }px)`;
      } else if (window.innerWidth > 3840) {
        mediaItem.style.transform = `scale(${scale5k}) translateY(${
          val * -speed
        }px)`;
      } else {
        mediaItem.style.transform = `translateY(${val * -speed}px)`;
      }
    });
  }
}

customElements.define("social-section", SocialSection);
